import React from 'react'
import { useRecoilState } from 'recoil'
import { isOpenGuestSignUpModalState } from '../../common/atoms/checkout'

export default function GuestNotification() {
  const [, setIsOpenGuestSignUpModal] = useRecoilState(
    isOpenGuestSignUpModalState,
  )

  return (
    <div
      className={
        'mb-2.5 flex w-full flex-row items-center gap-6 bg-fizz-900 px-4 py-3.5 md:w-96 lg:w-128 opacity-95'
      }
    >
      <div>
        <h6 className={'text-body-semibold text-white'}>
          You are using a guest account.
        </h6>
        <div className={'text-body-normal mt-1.5 text-white'}>
          To proceed faster and to save your preferences, we suggest you create
          an account{' '}
          <span
            className={'cursor-pointer text-bung-400'}
            onClick={() => {
              setIsOpenGuestSignUpModal(true)
            }}
          >
            here
          </span>
          .
        </div>
      </div>

      <div className={'shrink-0'}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='50'
          height='50'
          viewBox='0 0 50 50'
          fill='none'
        >
          <g id='annonymous 1'>
            <g id='Group'>
              <path
                id='Vector'
                d='M43.2969 21.0938H42.5938C42.1562 11.7499 34.4531 4.26559 25 4.26559C15.5469 4.26559 7.84378 11.7499 7.40623 21.0938H6.70309C3.87497 21.0938 1.5625 23.3906 1.5625 26.2343C1.5625 29.0625 3.87497 31.3749 6.70309 31.3749H43.2969C46.125 31.3749 48.4375 29.0625 48.4375 26.2343C48.4375 23.3906 46.125 21.0938 43.2969 21.0938ZM43.2969 28.2499H6.70309C5.59378 28.2499 4.6875 27.3437 4.6875 26.2343C4.6875 25.1094 5.59378 24.2188 6.70309 24.2188H43.2969C44.4062 24.2188 45.3125 25.1094 45.3125 26.2343C45.3125 27.3437 44.4062 28.2499 43.2969 28.2499Z'
                fill='#414E69'
              />
              <path
                id='Vector_2'
                d='M35.7813 33.9531C33.0781 33.9531 30.8125 35.7968 30.125 38.2812H19.8749C19.1875 35.7968 16.9219 33.9531 14.2187 33.9531C10.9844 33.9531 8.32812 36.5937 8.32812 39.8438C8.32812 43.0937 10.9844 45.7343 14.2187 45.7343C16.9219 45.7343 19.1875 43.8906 19.8749 41.4062H30.125C30.8124 43.8906 33.0781 45.7343 35.7813 45.7343C39.0156 45.7343 41.6718 43.0937 41.6718 39.8438C41.6718 36.5937 39.0156 33.9531 35.7813 33.9531Z'
                fill='#414E69'
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  )
}
